import { Warning20Filled } from '@fluentui/react-icons';
import { IconLabel } from '@shared/components';

type TProps = {
  ruleErrors: string[];
};

const CustomRuleErrors = ({ ruleErrors }: TProps) => {
  if (!ruleErrors.length) return null;
  return (
    <div>
      <IconLabel icon={<Warning20Filled />}>Approval rules violation:</IconLabel>
      <ul className="list-disc pl-6 text-red-500 marker:text-neutralFg-1">
        {ruleErrors.map((err, i) => (
          <li key={i}>{err}</li>
        ))}
      </ul>
    </div>
  );
};

export default CustomRuleErrors;
